import React, { useEffect, useState } from "react";
import useStyles from "../../../assets/styles/styles";
import {
    Box,
    Typography,
    IconButton,
    Divider,
    CircularProgress,
    Autocomplete,
    FormControl,
    InputLabel,
    ClickAwayListener,
} from "@material-ui/core";
import TuneIcon from '@material-ui/icons/Tune';
import "../../AskTurn/SelectDateDrawer/doctorCalendarAgenda.css";
import MovementsCard from "../../Billing/Movements/MovementsCard";
import HeaderCard from "../../Billing/Movements/HeaderCard";
import ControlPointOutlinedIcon from '@material-ui/icons/ControlPointOutlined';
import TextField from '@mui/material/TextField';
import NotFound from "../../../components/HomeLogged/NotFound";
import CustomButton from "../../../controls/Button/CustomButton";
import { LocalizationProvider, MobileDatePicker } from "@material-ui/lab";
import { es } from "date-fns/locale";
import AdapterDateFns from "@material-ui/lab/AdapterDateFns";
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';

const TabEvolution = ({
    modelEvolutions,
    selectedSpecialty,
    visibleItems,
    loadingMore,
    handleClickSeeMore,
    months,
    specialtiesByDoctor,
    isLoading,
    setSelectedSpecialty,
    loading,
    isInitialLoad, 
    setIsInitialLoad,
}) => {
    const classes = useStyles();
    const [openPicker, setOpenPicker] = useState(false);
    const [dateStart, setDateStart] = useState(new Date());
    const [dateEnd, setDateEnd] = useState(new Date());



    useEffect(() => {
            const savedFilters = localStorage.getItem('ViewFilters');
            if (savedFilters) {
                const parsedFilters = JSON.parse(savedFilters);
                const { selectedSpecialty: savedSpecialty, dateStart: savedDateStart, dateEnd: savedDateEnd, isInitialLoad: savedIsInitialLoad } = parsedFilters;
    
                if (savedSpecialty) {
                    setSelectedSpecialty(savedSpecialty);
                }
    
                if (!savedIsInitialLoad && savedDateStart && savedDateEnd) {
                    setDateStart(new Date(savedDateStart));
                    setDateEnd(new Date(savedDateEnd));
                    setIsInitialLoad(false);
                }
            }
        }, []);


    const filteredEvolutions = React.useMemo(() => {
        if (!modelEvolutions || modelEvolutions.length === 0) {
            return [];
        }

        let filtered = modelEvolutions?.filter((item) => {
            const matchesSpecialty =
                !selectedSpecialty ||
                selectedSpecialty === "TODAS" ||
                item.especialidad.toLowerCase().includes(selectedSpecialty.toLowerCase());

            if (isInitialLoad) {
                return matchesSpecialty;
            }

            const months = {
                Enero: 0,
                Febrero: 1,
                Marzo: 2,
                Abril: 3,
                Mayo: 4,
                Junio: 5,
                Julio: 6,
                Agosto: 7,
                Septiembre: 8,
                Octubre: 9,
                Noviembre: 10,
                Diciembre: 11,
            };

            const itemDate = new Date(
                parseInt(item.fechaFormateada.anio),
                months[item.fechaFormateada.mes],
                parseInt(item.fechaFormateada.dia)
            );

            const startDate = dateStart ? new Date(dateStart).setHours(0, 0, 0, 0) : null;
            const endDate = dateEnd ? new Date(dateEnd).setHours(23, 59, 59, 999) : null;

            const isInDateRange =
                (!startDate || itemDate >= startDate) &&
                (!endDate || itemDate <= endDate);

            return matchesSpecialty && isInDateRange;
        });

        return filtered.slice(0, visibleItems);
    }, [modelEvolutions, selectedSpecialty, dateStart, dateEnd, isInitialLoad, visibleItems]);


    const handleDateChange = (isStart, newValue) => {
        setIsInitialLoad(false);

        if (isStart) {
            setDateStart(newValue);
        } else {
            setDateEnd(newValue);
        }
    };


    const dateDropDown = () => {
        return (
            <Box style={{ alignSelf: "center" }} className={`${classes.headerFiltro} ${classes.marginTop}`}>

                <FormControl className={classes.medicalHistoryDateSelectorFrom}>
                    <InputLabel className={`${classes.txtSubtitleCalendar} ${classes.fontSize15}`} shrink  >{"DESDE"}</InputLabel>
                    <Box className={classes.top22} style={{ display: "flex", justifyContent: "space-between" }}>
                        <LocalizationProvider locale={es} dateAdapter={AdapterDateFns}  >
                            <MobileDatePicker
                                cancelText="Cancelar"
                                toolbarTitle=""
                                value={dateStart}
                                onChange={(newValue) => handleDateChange(true, newValue)}
                                renderInput={(params) => <TextField {...params} />}
                                format="dd/MM/YYYY"
                            />
                        </LocalizationProvider>
                        <CalendarTodayIcon />
                    </Box>
                </FormControl>

                <FormControl className={classes.medicalHistoryDateSelectorUntil} >
                    <InputLabel className={`${classes.txtSubtitleCalendar} ${classes.fontSize15}`} shrink  >{"HASTA"}</InputLabel>
                    <Box className={classes.top22} style={{ display: "flex", justifyContent: "space-between", }}>
                        <LocalizationProvider locale={es} dateAdapter={AdapterDateFns}  >
                            <MobileDatePicker
                                cancelText="Cancelar"
                                toolbarTitle=""
                                value={dateEnd}
                                onChange={(newValue) => handleDateChange(false, newValue)}
                                renderInput={(params) => <TextField {...params} />}
                                format="dd/MM/YYYY"
                            />
                        </LocalizationProvider>
                        <CalendarTodayIcon />
                    </Box>
                </FormControl>

            </Box>
        );
    }


    const dateFilterButton = () => {
        return (
            <ClickAwayListener mouseEvent="onMouseDown" touchEvent="onTouchStart" onClickAway={handleClickAway}>
                <Box style={{ position: "relative" }}>
                    <CustomButton
                        onClick={handleClick}
                        customClass={`${classes.btnFilterAppointment} ${classes.dateFilterButton}`}
                        icon={<TuneIcon className={classes.iconFilter} />}
                    />
                    {
                        openPicker &&
                        (
                            <Box container alignItems="center" className={`${classes.dropDownMedicalHistory} ${classes.dropdown}`} style={{ zIndex: 1 }}>
                                <Typography className={`${classes.txtCardDescription} ${classes.txtEllipsis}`}>{"PERIODO"}</Typography>
                                <Divider classes={{ root: classes.dividerFilter }} />
                                {dateDropDown()}
                            </Box>
                        )
                    }
                </Box>
            </ClickAwayListener>
        );
    }



    const handleClickAway = () => {
        setOpenPicker(false);
    };


    const handleClick = () => {
        setOpenPicker((prev) => !prev);
    };

    return (
        <>

                <Box className={classes.appointmentsAutocompleteContainer}>
                    {(specialtiesByDoctor?.length > 0 && !isLoading) ?
                        <>
                            <Typography className={classes.appointmentsAutocompleteLabels}>
                                Especialidad
                            </Typography>
                            <Autocomplete
                                freeSolo
                                clearText={'Borrar'}
                                loading={isLoading}
                                clearOnEscape={false}
                                renderInput={(params) => (
                                    <TextField {...params} variant="outlined" />
                                )}
                                options={specialtiesByDoctor}
                                filterOptions={(options, { inputValue }) => {
                                    if (!inputValue) return options;
                                    return options.filter(option =>
                                        option.toLowerCase().includes(inputValue.toLowerCase())
                                    );
                                }}
                                onInputChange={(e, newValue) => {
                                    setSelectedSpecialty(newValue || '');
                                    if (!isInitialLoad) {
                                        setIsInitialLoad(false);
                                    }
                                }}
                                className={`${classes.specialtySelection}`}
                                value={selectedSpecialty}
                            />
                            <Box className={`${classes.rangeFilterPatientDetails} ${classes.appointmentsAutocompleteContainer}`}>
                                {dateFilterButton()}
                            </Box>
                        </>
                        :
                        <Box className={`${classes.boxPointsDrawer} ${classes.centeredBox} ${classes.circularProgress}`}>
                            <CircularProgress />
                        </Box>
                    }
                </Box>
            <Box className={`${classes.listCardMedicalHistory}`}  >
                {loading ? (
                    <Box className={`${classes.boxPointsDrawer} ${classes.centeredBox} ${classes.whiteCircularProgress}`}>
                        <CircularProgress />
                    </Box>
                ) : filteredEvolutions?.length > 0 ? (
                    <>
                        {filteredEvolutions?.slice(0, visibleItems)?.map((item, i) => (
                            <MovementsCard
                                key={item?.id || i}
                                count={item?.count}
                                index={i}
                                headerIcon={
                                    <HeaderCard
                                        day={item?.fechaFormateada?.nombreDia}
                                        numberDay={item?.fechaFormateada?.dia}
                                        month={months[item?.fechaFormateada?.mes]}
                                        year={item?.fechaFormateada?.anio}
                                    />
                                }
                                description={
                                    <Box className={classes.descriptionEvolutionCard}>
                                        <Typography className={classes.patientDetailsText} >
                                            {item?.especialidad}
                                        </Typography>
                                        <Typography className={classes.patientDetailsTextInfo} >
                                            Profesional: {item?.profesional}
                                        </Typography>
                                        {item?.diagnostico && (
                                            <Typography className={classes.patientDetailsTextInfo}>
                                                Diagnóstico: {item.diagnostico}
                                            </Typography>
                                        )}
                                    </Box>
                                }
                                buttonZone={
                                    <Box className="buttonZoneSection">
                                        <Box
                                            className={`${classes.sectionButtons} ${classes.btnAuthorizationCard} buttonZoneContainer`}
                                        >
                                            <Box className={classes.buttonZonePrescriptionPage}>
                                                <IconButton onClick={handleClickSeeMore(item)} customClass={classes.customHeaderBtn}>
                                                    <Typography className={`${classes.viewPatientDetails} ${classes.txtEllipsis}`} >
                                                        VER
                                                    </Typography>
                                                    <ControlPointOutlinedIcon className={classes.iconFilterPatientDetails} />
                                                </IconButton>
                                            </Box>
                                        </Box>
                                    </Box>
                                }
                            />
                        ))}
                        {loadingMore && filteredEvolutions?.length > visibleItems && (
                            <Box display="flex" justifyContent="center" width="100%" mt={2} mb={2}>
                                <CircularProgress />
                            </Box>
                        )}
                    </>
                ) : (
                    <NotFound
                        customMsg={
                            <Box className={classes.contentNotFound}>
                                <Typography>No tenés evoluciones</Typography>
                            </Box>
                        }
                        wsItem={filteredEvolutions}
                        fullItem={filteredEvolutions}
                    />
                )}

            </Box>

        </>
    );
};

export default TabEvolution;